import axios from "axios";
import axiosRetry from "axios-retry";

axiosRetry(axios, {
  retries: 5,
  retryDelay: (retryCount) => {
    return retryCount * 300; // retry after 1, 2, 3, ... seconds
  },
});

export { axios };
